'use strict';
var angular = require('angular');

var metadataCtrl = [function () {
    var _this = this;
    if (!this.metadataCollection) {        
        this.metadataCollection = [].concat(this.defaultCollection);
    }    

    this.addField = function (newValue) {
        if (!newValue.key || !newValue.value) {
            return;
        }

        _this.metadataCollection.push({
            key: newValue.key,
            value: newValue.value,
            id: Math.random().toString(36).substr(2, 9)
        });
        _this.newPayload = {
            key: null,
            value: null,            
        };
    };

    this.removeValue = function (index) {
        _this.metadataCollection.splice(index, 1);
        
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            metadataCollection: '=',
            defaultCollection: '=',
            titleKey:'=',
            titleValue: '=',
        },
        controller: metadataCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/metadataDirective.html'
    };
};
